<div class="sa-auth-container">
  @if(showSpinner){
    <div class="sa-auth-welcome-spinner-container d-flex items-center justify-center">
      <span class="sa-auth-spinner"></span>
    </div>
  }

  @if(showWelcomeMsg){
    <div class="sa-auth-welcome-wrapper">
      
      <div class="sa-welcome-container h-100 d-flex flex-col items-center justify-center">
        <div class="sa-welcome-view h-100 d-flex flex-col items-center justify-center">
            <div class="sa-welcome-card-box d-flex flex-col items-center justify-center">
                <div class="sa-welcome-logo">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 80" class="sa-welcome-logo-svg" fill="none"><path fill="#1B77E4" d="M54.743 43.029c-1.673 2.893-5.393 3.888-8.291 2.217a6.06 6.06 0 0 1-2.221-8.277c1.673-2.893 5.392-3.888 8.291-2.217a6.06 6.06 0 0 1 2.221 8.277ZM41.191 34.54 2.353 2.395C1.375 1.585 1.948 0 3.22 0h25.56c.55 0 1.045.33 1.253.837l13.279 32.144c.538 1.304-1.031 2.458-2.118 1.558l-.002.001ZM38.002 38.492h-23.8a1.355 1.355 0 0 1-1.248-.826L.114 7.343C-.439 6.038 1.134 4.87 2.23 5.775l36.638 30.323c.978.81.405 2.395-.865 2.395ZM38.002 41.341h-23.8c-.545 0-1.036.325-1.248.827L.114 72.49c-.553 1.306 1.02 2.474 2.115 1.568l36.638-30.322c.978-.81.405-2.395-.865-2.395ZM41.191 45.46 2.353 77.605c-.978.81-.405 2.394.866 2.394h25.56c.55 0 1.045-.33 1.253-.837l13.279-32.144c.538-1.304-1.031-2.457-2.118-1.557l-.002-.002Z"/></svg>
                </div>
                <div class="sa-welcome-title d-flex">
                    <div class="title">
                        {{welcomeSuperText}}
                    </div>
                    <div class="sub-title">
                        {{welcomeTitle}}
                    </div>
                </div>
                <div class="sub-title-2">
                    {{welcomeSubTitle}}
                </div>
            </div>
            <div class="sa-welcome-spinner d-flex flex-col">
              <div class="sa-auth-spinner-container">
                <span class="sa-spinner"></span>
              </div>
              <span class="sa-welcome-spinner-text font-12 text-center fw-400">Launching now...</span>
            </div>
        </div>
    </div>
    </div>
  }
  @if(showFailedMsg){
    <div class="sa-auth-failure-container">
      <div class="sa-auth-faulure">
        <div class="">Something went wrong, logout and try again</div>
        <div class="">Code: {{showFailedMsg.code}}</div>
        <sa-button [text]="'Logout and try again'" [type]="'primary'" [size]="'large'" [ImagePath]="'../assets/signOut.svg'" [iconPosition]="'left'" (onClickEvent)="logout()"></sa-button>
      </div>
    </div>
  }
</div>
